/* lp-ingredients-hub.js
   Behavior for sections/lp-ingredients-hub.liquid: product filter pills + ingredient search.
   Lives in an asset (not inline in the section) because admin theme-editor roundtrips can
   strip inline <script> from section markup. Idempotent init + shopify:section:load support. */
(function () {
  function initHub(root) {
    if (!root || root.dataset.inghInit === '1') return;
    root.dataset.inghInit = '1';

    var tabs = root.querySelectorAll('[data-ingh-tab]');
    var panels = root.querySelectorAll('[data-ingh-panel]');
    var search = root.querySelector('.ingh-search__input');
    var noResults = root.querySelector('.ingh-noresults');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-ingh-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-ingh-panel') === key);
        });
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        root.classList.toggle('ingh--searching', q.length > 0);
        var any = false;
        root.querySelectorAll('.ingh-card').forEach(function (card) {
          var match = (card.getAttribute('data-ingh-name') || '').indexOf(q) !== -1;
          if (q && !match) {
            card.setAttribute('data-ingh-hidden', '');
          } else {
            card.removeAttribute('data-ingh-hidden');
            any = true;
          }
        });
        if (noResults) noResults.hidden = !(q.length > 0 && !any);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.ingh').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('.ingh') : null;
    initHub(root);
  });
})();
